module.exports = require("./zh-Hans");